import React from "react";

function GetScriptLending() {
  const logos = [
    { name: "Aave", img: "/assets/img/brand/1.png" },
    { name: "PancakeSwap", img: "/assets/img/brand/2.png" }, 
    { name: "Compound", img: "/assets/img/brand/3.png" },
    { name: "MakerDAO", img: "/assets/img/brand/4.png" },
    { name: "Yearn Finance", img: "/assets/img/brand/5.png" }
  ];

  return (
    <div className="brand-area pt-100 pb-100" style={{ background: "#ffffff" }}>
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-lg-8 offset-lg-2">
            <h2 className="title fw-bold" style={{ fontSize: "36px" }}>Our Battle-Tested Scripts</h2>
            <p className="mt-2 text-muted">Leverage the security of world-class protocols with our thoroughly audited clone solutions.</p>
          </div>
        </div>
        <div className="row justify-content-center align-items-center g-5">
          {logos.map((logo, index) => (
            <div className="col-lg-2 col-md-4 col-6" key={index}>
              <div 
                className="logo-item text-center p-2" 
                style={{ 
                  filter: "grayscale(100%) opacity(60%)", 
                  transition: "all 0.4s ease",
                  cursor: "pointer"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.filter = "grayscale(0%) opacity(100%)";
                  e.currentTarget.style.transform = "scale(1.1)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.filter = "grayscale(100%) opacity(60%)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <img src={logo.img} alt={logo.name} style={{ width: "100%", maxWidth: "120px", height: "auto" }} />
                <h6 className="mt-3 fw-bold text-muted small">{logo.name}</h6>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GetScriptLending;
